import React from 'react';
import './slider.styl';

import PlayIcon from 'react-icons/lib/io/ios-play';
import PauseIcon from 'react-icons/lib/io/ios-pause';

import * as AppActions from '../../modules/App/AppState';

const PlayButton = props => {
  const onClick = () => {
    props.dispatch(AppActions.togglePlaying());
  }

  return (
    <div onClick={onClick} className="ifdw-slider--playbutton">
      <span className="ifdw-slider--icon">{props.isPlaying ? <PauseIcon /> : <PlayIcon className="play-icon"/>}</span>
    </div>
  );
};

export default PlayButton;



/** WEBPACK FOOTER **
 ** ./src/components/Slider/PlayButton.js
 **/